export const FORM_FIELD_KINDS = {
  INPUT: 'input',
  DROPDOWN: 'dropdown',
  TEXTAREA: 'textarea',
  CHECKBOX: 'checkbox',
  FILE: 'file',
} as const;

export const INPUT_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
} as const;

export type FormFieldKind = (typeof FORM_FIELD_KINDS)[keyof typeof FORM_FIELD_KINDS];
export type InputType = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES];

export const stateOptions = [
  { label: 'ACT', value: 'ACT' },
  { label: 'NSW', value: 'NSW' },
  { label: 'NT', value: 'NT' },
  { label: 'QLD', value: 'QLD' },
  { label: 'SA', value: 'SA' },
  { label: 'TAS', value: 'TAS' },
  { label: 'VIC', value: 'VIC' },
  { label: 'WA', value: 'WA' },
];

export const areaOfWorkOptions = [
  {
    label: 'Building Professional / Tradesperson',
    value: 'Building Professional / Tradesperson',
  },
  {
    label: 'Construction / Volume Builder',
    value: 'Construction / Volume Builder',
  },
  { label: 'Manufacturer', value: 'Manufacturer' },
  { label: 'Cabinet Maker / Joiner', value: 'Cabinet Maker / Joiner' },
  { label: 'Reseller', value: 'Reseller' },
  { label: 'Retailer', value: 'Retailer' },
  {
    label: 'DIYer / Homeowner / Renovator',
    value: 'DIYer / Homeowner / Renovator',
  },
  { label: 'Architect / Designer', value: 'Architect / Designer' },
];

export const hearAboutOptions = [
  { label: 'Current customer', value: 'Current Account Customer' },
  { label: 'Google search', value: 'Google Search' },
  { label: 'Porta email newsletter', value: 'Porta Email Newsletter' },
  { label: 'Social media', value: 'Social Media' },
  {
    label: 'Word of mouth',
    value: 'Word of Mouth (Please specify who recommended Porta)',
  },
];

export const enquiryTypeOptions = [
  { label: 'General', value: 'General Enquiry' },
  { label: 'Sales support', value: 'Sales Support' },
  { label: 'Accounts', value: 'Accounts' },
  { label: 'Technical', value: 'Technical' },
  { label: 'Marketing/PR', value: 'Marketing/PR' },
];

export const CONTACT_FORM_MAX_LENGTH_DEFAULT = 1000;

export const HUBSPOT_ERROR_CODES = {
  HUBSPOT_ERROR: 'HUBSPOT_ERROR',
  RETRYABLE: 'RETRYABLE',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  CONFIG_ERROR: 'CONFIG_ERROR',
};

export type HubSpotErrorCode = (typeof HUBSPOT_ERROR_CODES)[keyof typeof HUBSPOT_ERROR_CODES];

export const GENERIC_HUBSPOT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const INPUT_MAX_LENGTH = {
  firstname: 50,
  lastname: 50,
  email: 255,
  company: 255,
};

export const contactFormFieldsConfig = [
  {
    kind: FORM_FIELD_KINDS.INPUT,
    name: 'firstname',
    label: 'First Name',
    required: true,
    placeholder: 'Enter your first name',
  },
  {
    kind: FORM_FIELD_KINDS.INPUT,
    name: 'lastname',
    label: 'Last Name',
    required: true,
    placeholder: 'Enter your last name',
  },
  {
    kind: FORM_FIELD_KINDS.INPUT,
    name: 'email',
    label: 'Email',
    required: true,
    type: INPUT_TYPES.EMAIL,
    placeholder: 'Enter your email address',
  },
  {
    kind: FORM_FIELD_KINDS.INPUT,
    name: 'phone',
    label: 'Phone',
    required: true,
    placeholder: 'Enter your phone number',
  },
  {
    kind: FORM_FIELD_KINDS.INPUT,
    name: 'company',
    label: 'Company Name',
    placeholder: 'Enter your company name',
  },
  {
    kind: FORM_FIELD_KINDS.DROPDOWN,
    name: 'state',
    label: 'State/Region',
    required: true,
    placeholder: 'Select state/region',
    options: stateOptions,
  },
  {
    kind: FORM_FIELD_KINDS.DROPDOWN,
    name: 'area_of_work',
    label: 'Area of Work',
    required: true,
    placeholder: 'Select area of work',
    options: areaOfWorkOptions,
  },
  {
    kind: FORM_FIELD_KINDS.DROPDOWN,
    name: 'where_did_you_hear_about_porta_',
    label: 'Where did you hear about Porta?',
    placeholder: 'Select one',
    options: hearAboutOptions,
  },
  {
    kind: FORM_FIELD_KINDS.DROPDOWN,
    name: 'enquiry_type___dropdown',
    label: 'Enquiry Type',
    required: true,
    placeholder: 'Select enquiry type',
    options: enquiryTypeOptions,
  },
  {
    kind: FORM_FIELD_KINDS.TEXTAREA,
    name: 'message',
    label: 'Message',
    required: true,
    placeholder: 'Please enter your message or enquiry details',
    fullWidth: true,
    maxLength: 1000,
  },
  {
    kind: FORM_FIELD_KINDS.CHECKBOX,
    name: 'newsletter',
    label: 'Subscribe to our newsletter',
    fullWidth: true,
    description: 'Receive email updates of news, upcoming events, product information and timber trends.',
  },
];

export const CONTACT_MESSAGES = {
  success: 'Thank you for your enquiry.',
  successSubtext: 'One of our team member will be in contact with you soon.',
  error: 'Something went wrong. Please try again.',
};
